import { ShieldCheck, Leaf, Clock, MapPin } from "lucide-react";

const stats = [
  { value: "4000", suffix: "PSI", label: "Industrial Pressure" },
  { value: "12+", suffix: "YRS", label: "Local Experience" },
  { value: "1500+", suffix: "JOBS", label: "Completed Cleanings" },
  { value: "100%", suffix: "", label: "Satisfaction Promise" },
];

const reasons = [
  {
    icon: ShieldCheck,
    title: "Fully insured & WCB covered",
    desc: "Liability, equipment, and worker coverage so your property is protected end-to-end.",
  },
  {
    icon: Leaf,
    title: "Biodegradable detergents",
    desc: "Surface-safe and pet-friendly chemistry that doesn't trash your lawn or the harbour.",
  },
  {
    icon: Clock,
    title: "On-time, every time",
    desc: "Tight windows, real arrival texts, and no ghosting. We respect your day.",
  },
  {
    icon: MapPin,
    title: "Truly mobile",
    desc: "Hot-water rigs, water tanks, and generators — we don't even need your hose.",
  },
];

export default function Stats() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative px-6 md:px-12 lg:px-20 py-24 md:py-32 border-b border-[#2A2A2A] overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.08]"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/7718585/pexels-photo-7718585.jpeg')",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" aria-hidden />

      <div className="relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A] mb-24">
          {stats.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="bg-[#050505] p-8 md:p-10 hover:bg-[#0a0a0a] transition-colors"
            >
              <div className="flex items-baseline gap-2">
                <span className="font-display font-bold text-5xl md:text-6xl text-white">
                  {s.value}
                </span>
                {s.suffix && (
                  <span className="font-display font-bold text-lg text-[#FFD600] uppercase">
                    {s.suffix}
                  </span>
                )}
              </div>
              <div className="mt-3 text-xs uppercase tracking-[0.25em] text-gray-400">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#FFD600]">
              02 — Why Big Bubbles
            </span>
            <h2 className="font-display font-bold uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mt-4">
              Built for the
              <br />
              East Coast.
              <br />
              <span className="text-stroke">No shortcuts.</span>
            </h2>
            <p className="mt-6 text-gray-400 leading-relaxed">
              Salt air, snow plow grit, ocean mist — Saint John doesn't go easy on surfaces. We
              built our rig and our process for exactly that.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
            {reasons.map((r, i) => {
              const Icon = r.icon;
              return (
                <div
                  key={i}
                  data-testid={`reason-${i}`}
                  className="bg-[#0A0A0A] hover:bg-[#101010] p-8 transition-colors"
                >
                  <Icon size={26} className="text-[#00E5FF]" />
                  <h3 className="font-display font-semibold uppercase text-lg mt-5 tracking-tight">
                    {r.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-400 leading-relaxed">{r.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
